import {createSlice} from '@reduxjs/toolkit'

const appSlice = createSlice({
    name: 'IndustryReducer',
    initialState: {
        keyword: '',
        orderBy : '',
        order : '' ,
        page:0,
        rowsPerPage:50,
        tabValue: 0
    },
    reducers: {
        setIndustryKeyword(state, action) {
            state.keyword = action.payload;
        },
        setOrderBy (state,action) {
            state.orderBy = action.payload;
        },
        setOrder (state,action) {
            state.order = action.payload;
        },
        setPage (state,action) {
            state.page = action.payload;
        },
        setRowsPerPage (state,action) {
            state.rowsPerPage = action.payload;
        },
        setTabValue (state,action) {
            state.tabValue = action.payload;
        },
        resetTabValue (state,action) {
            state.tabValue = 0;
        },
        resetOrderBy(state,action){
            state.orderBy = ''
        },
        resetOrder(state,action){
            state.order = ''
        },
        resetPage(state,action){
            state.page = 0
        },
        resetRowsPerPage(state,action){
            state.rowsPerPage = 50
        },
    }
});

export const {setTabValue, resetTabValue, setIndustryKeyword,setOrder,setOrderBy,setPage,setRowsPerPage,resetOrder,resetOrderBy,resetPage,resetRowsPerPage} = appSlice.actions;
export default appSlice.reducer
